import {
  PARTNER_POOL_SECTION,
  PARTNER_POOL_BULLETS,
  PARTNER_POOL_EXAMPLE,
  computePoolUsagePercent,
} from "@/constants/partnerPoolContent";
import { formatAiCredits } from "@/lib/formatAiCredits";

export { PARTNER_POOL_SECTION, PARTNER_POOL_BULLETS, PARTNER_POOL_EXAMPLE };

export const POOL_DIAGRAM = {
  poolIncluded: PARTNER_POOL_EXAMPLE.poolIncluded,
  poolUsed: PARTNER_POOL_EXAMPLE.poolUsed,
  usagePercent: computePoolUsagePercent(
    PARTNER_POOL_EXAMPLE.poolUsed,
    PARTNER_POOL_EXAMPLE.poolIncluded
  ),
};

export const formatPoolLabel = (used, included) =>
  `${formatAiCredits(used)} / ${formatAiCredits(included)} credits`;
